export default {"src":"/_next/static/media/company.492a05ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};